import React from "react";
import RestartBtn from "./btn/RestartBtn";

export default class Footer extends React.Component {

  render() {
    return (
      <div className="footer">
        <h2 className="footer__title">Select the difficulty level</h2>
        <SelectDifficult handleChange={this.props.changeDifficult}/>
        <RestartBtn handleClick={this.props.handleClickBtn} inner="Restart"/>
      </div>
    )
  }
}

class SelectDifficult extends React.Component {
  constructor(props) {
    super(props)

    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(event) {
    this.props.handleChange(event.target.value)
  }

  render() {
    return (
      <select className="footer__select" onChange={this.handleChange}>
        <option value={JSON.stringify({winScore: 100, difficult: "Easy"})}>Easy</option>
        <option value={JSON.stringify({winScore: 500, difficult: "Normal"})}>Normal</option>
        <option value={JSON.stringify({winScore: 1000, difficult: "Hard"})}>Hard</option>
      </select>
    )
  }
}